function Home() {
    try {
        return (
            <div className="min-h-screen" data-name="home-page">
                <div className="hero-section" data-name="hero">
                    <div className="container">
                        <h1 className="hero-title" data-name="hero-title">
                        River AI
                        </h1>
                        <p className="hero-description" data-name="hero-description">
                            一人公司/超級個體<br />
                            一個AI員工代替多人或部門
                        </p>
                        <button 
                            className="start-btn"
                            data-name="start-button"
                        >
                            馬上開始
                        </button>
                    </div>
                </div>

                <div className="features-section" data-name="features">
                    <div className="container">
                        <div className="features-header">
                            <h2 className="features-title">River AI 工作流</h2>
                            <a href="#" className="explore-link">查看全部</a>
                        </div>
                        <div className="features-grid">
                            <div className="feature-card green" data-name="feature-1">
                                <div className="feature-label">River AI 自動化</div>
                                <h3 className="feature-title">IG 頻道管理</h3>
                                <p className="feature-description">
                                    自動生成內容<br />排程發布<br />AI互動
                                </p>
                                <div className="feature-metric">
                                    <span className="feature-highlight">自動運作</span>
                                    <span className="arrow-icon">→</span>
                                </div>
                            </div>
                            <div className="feature-card blue" data-name="feature-2">
                                <div className="feature-label">River AI 自媒體</div>
                                <h3 className="feature-title">內容產生器</h3>
                                <p className="feature-description">
                                    自動發佈<br />Facebook/IG<br />Website
                                </p>
                                <div className="feature-metric">
                                    <span className="feature-highlight">極速產出</span>
                                    <span className="arrow-icon">→</span>
                                </div>
                            </div>
                            <div className="feature-card purple" data-name="feature-3">
                                <div className="feature-label">River AI 數據</div>
                                <h3 className="feature-title">資料處理</h3>
                                <p className="feature-description">
                                    自動整理<br />智能分類<br />即時同步
                                </p>
                                <div className="feature-metric">
                                    <span className="feature-highlight">無縫銜接</span>
                                    <span className="arrow-icon">→</span>
                                </div>
                            </div>
                            <div className="feature-card yellow" data-name="feature-4">
                                <div className="feature-label">River AI 語音助理</div>
                                <h3 className="feature-title">智能秘書</h3>
                                <p className="feature-description">
                                    工作管理<br />思路整理<br />智能分工
                                </p>
                                <div className="feature-metric">
                                    <span className="feature-highlight">事半功倍</span>
                                    <span className="arrow-icon">→</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    } catch (error) {
        console.error('Home page error:', error);
        reportError(error);
        return null;
    }
}

export default Home;